import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
type LegalLayoutProps = {
  title: string;
  updated: string;
  children: React.ReactNode;
};
const LegalLayout = ({
  title,
  updated,
  children
}: LegalLayoutProps) => {
  return <div className="min-h-screen w-full bg-[#F8FAFC] font-sans text-[#0B1220]" data-id="element-103" data-mp="doo6ihry94h6">
      <header className="bg-premium-gradient text-white py-4 px-4" data-id="element-104" data-mp="8wwb9txumakp">
        <div className="container mx-auto flex items-center justify-between gap-4" data-id="element-105" data-mp="mokm7twd2t03">
          <a href="/" className="inline-flex items-center gap-2 text-sm font-medium text-gray-200 hover:text-white transition-colors" data-id="element-106" data-mp="mqdwdj66nvcu">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-107" data-mp="wm8k2sp9kgmh" />
            Volver al inicio / Back home
          </a>
          <span className="font-heading font-bold text-lg tracking-tight" data-id="element-108" data-mp="ro7085k0kd9y">
            Carros <span className="text-accent" data-id="element-109" data-mp="2yewq19tali5y">de la Cruz</span>
          </span>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12" data-id="element-110" data-mp="2tgbzk23uecup">
        <article className="max-w-3xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-8 md:p-12" data-id="element-111" data-mp="5fmenv2mntch">
          <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-primary mb-2" data-id="element-112" data-mp="9gg3cqnw9c6f">
            {title}
          </h1>
          <p className="text-sm text-gray-500 mb-10" data-id="element-113" data-mp="ef97hshajqtx">{updated}</p>
          <div className="space-y-8" data-id="element-114" data-mp="j7apzw51ydse">{children}</div>
        </article>
      </main>

      <footer className="py-8 text-center text-sm text-gray-500" data-id="element-115" data-mp="o5ucpyrgztlt">
        <p data-id="element-116" data-mp="o5kmqb6fdmg4">
          © {new Date().getFullYear()} Carros de la Cruz — Pedro de la Cruz,
          Fleet Manager
        </p>
        <p className="mt-1" data-id="element-117" data-mp="x6isaxwii20t">21400 NW 2nd Ave, Miami Gardens, FL 33169</p>
      </footer>
    </div>;
};
type SectionProps = {
  heading: string;
  children: React.ReactNode;
};
export const LegalSection = ({
  heading,
  children
}: SectionProps) => <section data-id="element-118" data-mp="2yyyjtiorrq6z">
    <h2 className="font-heading font-bold text-xl text-primary mb-3" data-id="element-119" data-mp="2yz6v5658ung2">
      {heading}
    </h2>
    <div className="text-gray-700 leading-relaxed space-y-3 text-[15px]" data-id="element-120" data-mp="33xrpioxtecwl">
      {children}
    </div>
  </section>;
export default LegalLayout;